import { lazy } from "react";

// Select, preview and apply all live on the same page now — create/edit paths
// still resolve here so existing menu links and bookmarks keep working.
const routes = [
  {
    path: "/theme-personalization",
    element: lazy(() => import("../../pages/Saas/branding")),
  },
  {
    path: "/theme-personalization/create",
    element: lazy(() => import("../../pages/Saas/branding")),
  },
  {
    path: "/theme-personalization/edit/:id",
    element: lazy(() => import("../../pages/Saas/branding")),
  },
];

export default routes;
